import React from "react";
import styled from "styled-components";

import { inputGlow } from "../../utils/styles";

const Styled = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  border-radius: 0.2em;
  border: solid 1px #ccc;
  padding: 0.5em;
  font-family: inherit;
  font-size: inherit;
  transition: border-color 0.2s;
  resize: vertical;
  outline: none;

  ${inputGlow}

  &:focus {
    border: solid 1px #6f9eb3;
    background-color: #fcfdf3;
  }
  &:hover {
    border-color: #999;
  }

  &[disabled] {
    color: #888;
    background-color: #f7f7f7;
  }
  &[disabled]:hover {
    color: #888;
    background-color: #f7f7f7;
  }
`;

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: any;
}

const TextArea: React.FC<React.PropsWithChildren<Props>> = React.forwardRef<
  HTMLTextAreaElement,
  Props
>((props, ref) => {
  return <Styled {...props} ref={ref} />;
});

export default TextArea;
